import request from '@/utils/request'

let BannerApi = {
  /*列表*/
   bannerList(data, errorback) {
    return request._post('/shop/plus.banner.banner/index', data, errorback);
  },
  /*添加*/
  addBanner(data, errorback) {
    return request._post('/shop/plus.banner.banner/add', data, errorback);
  },
  /*获取数据*/
  getBanner(data, errorback) {
    return request._get('/shop/plus.banner.banner/edit', data, errorback);
  },

  /*保存*/
  saveBanner(data, errorback) {
    console.log(data)
    return request._post('/shop/plus.banner.banner/edit', data, errorback);
  },
  /*删除*/
  delBanner(data, errorback) {
    return request._post('/shop/plus.banner.banner/delete', data, errorback);
  },

}
export default BannerApi;



// WEBPACK FOOTER //
// ./src/api/banner.js